import { Component, Input, OnInit } from "@angular/core";
import { ClientService } from "src/app/services/client.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  @Input() title = "";

  clientFullName: string;
  isClientFullNameLoading: boolean;

  constructor(private readonly _clientService: ClientService) {
    this.clientFullName = this._clientService.lastKnownClientFullName ?? "";
    this.isClientFullNameLoading = !this.clientFullName;
  }

  ngOnInit(): void {
    this._clientService.getClientFullName().subscribe(fullName => {
      this.clientFullName = fullName;
      this.isClientFullNameLoading = false;
    });
  }
}
